import Modal from "../Modal";
import DealNewForm from "../../forms/deal/DealNewForm";
import { useTranslation } from "../../../hooks/useTranslation";

export default function DealNewModal({show, handleClose, items = null, title = null}) {
    const { t } = useTranslation();
    const defaultTitle = t("deals.newRegistration");
    return (
        <Modal title={title || defaultTitle} show={show} handleClose={handleClose} width="1000px">
            <DealNewForm handleClose={handleClose} items={items}/>
        </Modal>
    );
};